const french = {
  steps: {
    EmailVerification: "Vérification de l'E-mail",
    RequestAccess: "Demande d'accès",
    UserInfo: 'Informations de Contact',
    SelectCompany: 'Sélectionnez une entreprise',
    BusinessInfo: 'Informations sur la société',
    Diversity: 'Informations sur la diversité',
    Products: 'Produits et services',
    Login: 'Informations de connexion'
  },
  backButtonLabel: 'Retour',
  continueButtonLabel: 'Continuer',
  affirmativeLabel: 'Oui',
  negativeLabel: 'Non',
  expandIconTooltip: 'Accroîtrez',
  collapseIconTooltip: 'Effondrez',
  emailCheck: {
    languageLabel: 'Sélectionnez la langue',
    validEmail: 'Veuillez introduire un e-mail valide',
    enterEmail: 'Entrez Votre E-mail',
    welcome: ''
  },
  emailValidationCode: {
    emailValidationTitle:
      'Un e-mail a été envoyé à {email} avec un code de vérification. Veuillez saisir le code ci-dessous.',
    termsOfUse: "Termes et Conditions d'Utilisation",
    aknowledge: `Votre utilisation du site est régie par ces {terms}. En cliquant sur "Continuer" ci-dessous, vous reconnaissez avoir lu ces conditions d'utilisation et acceptez que, chaque fois que vous utilisez le site, vous serez lié par les conditions d'utilisation accessibles via le(s) lien(s) sur la page de connexion.`,
    validationCodeLabel: 'Code de vérification',
    sendCodeLabel: 'Envoyer le code',
    resendCodeLabel: 'Renvoyer le code',
    validationErrorMessage: 'Veuillez insérer le code de vérification reçu!',
    incorrectValidationCode: 'Code de vérification incorrect',
    userNotAllowToProceedMsg: "Il y a un compte inactif associé à cette adresse e-mail. S'il vous plaît contactez",
    paSupportEmail: 'support@poweradvocate.com',
    reSentLabel: 'Votre code de vérification a été renvoyé',
    modalActiveAccount:
      "Merci de vous être inscrit auprès. Un compte actif existe avec l'adresse e-mail que vous avez saisie",
    modalEmailExistsText: "Les comptes existants suivants ont été trouvés avec l'adresse e-mail {email}",
    modalEmailExistsGuide:
      "Veuillez choisir un compte existant ou créer un nouveau compte pour une autre entreprise.",
    newUserAccountLabel: 'Créer un nouveau compte'
  },
  requestAccess: {
    helpText:
      "Pour demander l'accès à cet événement d'enchère, indiquez une raison ci-dessous et cliquez sur Continuer. Votre demande d'accès sera approuvée ou refusée par le coordonnateur de l'événement et vous recevrez des instructions supplémentaires par e-mail.",
    textAreaLabel: 'Reason for request for access',
    modalEmailNotInvitedText: [
      "Votre adresse e-mail ne correspond pas à la personne qui a été initialement invitée, peut-être parce que l'invitation vous a été transmise.",
      'Veuillez cliquer sur « Annuler » pour saisir une autre adresse e-mail ou cliquez sur « OK » pour terminer la configuration de votre compte.',
      "Votre demande d'accès sera approuvée ou refusée par le {role} et vous recevrez des instructions supplémentaires par e-mail."
    ],
    eventCoordinator: "Coordonnateur de l'événement",
    portalOwner: 'Portail Propriétaire',
    contractOwner: 'Propriétaire du contrat',
    modalCancelButton: 'Annuler',
    modalOkButton: 'Ok',
    modalLoginButton: 'Login'
  },
  userInfo: {
    salutation: [
      { label: '----', value: '' },
      { label: 'Mx.', value: 'Mx.' },
      { label: 'Mr.', value: 'Mr.' },
      { label: 'Mme.', value: 'Mrs.' },
      { label: 'Mlle.', value: 'Ms.' },
      { label: 'Dr.', value: 'Dr.' }
    ],
    firstName: 'Prénom',
    lastName: 'Nom de Famille',
    workPhone: 'Téléphone de Travail',
    jobTitle: 'Intitulé du poste',
    timeZone: 'Sélectionnez le fuseau horaire*',
    reStart: "Recommencer l'enregistrement"
  },
  companySelection: {
    helpText: "Recherchez votre entreprise dans notre base de données. Si elle n'existe pas, ajoutez-la.",
    companySearchLabel: 'Sélectionner une Entreprise',
    locationControlsHelpText: 'Veuillez remplir les champs suivants',
    siteName: 'Nom du Site',
    address1: 'Adresse 1',
    address2: 'Adresse 2',
    country: 'Pays',
    city: 'Ville',
    stateProvince: 'État ou province',
    zip: 'Zip / Code Postal',
    phoneNumber: 'Numéro de téléphone du site',
    siteTypeCode: 'Type de Site',
    companyNotFound: `La société "{text}" n'est pas répertoriée? Cliquez pour l'ajouter`,
    tableCompanyNotFound: "La société n'a pas d'emplacements. Veuillez ajouter un nouvel emplacement ci-dessous.",
    tableTitle: "Sélectionnez l'un des emplacements existants",
    tableSelect: 'Sélectionner',
    tableSiteName: 'Nom du site',
    tableAddress: 'Adresse',
    tableStateProvince: 'État/Province',
    tableZip: 'Code Postal',
    tablePhone: 'Téléphone',
    loadingLabel: "Obtenir les emplacements de l'entreprise",
    radioLabel: 'Emplacement non répertorié? Ajouter un nouvel emplacement',
    companyDuplicatedName:
      "Ce nom de société existe déjà. Veuillez sélectionner l'entreprise existante ou mettre à jour le nom.",
    sortingLabelAlpha: 'Triez les sociétés par ordre alphabétique en ordre {sortOption}',
    sortingLabelUsers: "Triez les entreprises par nombre d'utilisateurs actifs en ordre {sortOption}",
    sortingLabelRelevancy: 'Réinitialiser le tri',
    sortAscending: 'croissant',
    sortDescending: 'décroissant',
    activeAccountsLabel: 'comptes actifs',
    domainSearchLabel:
      "Nous avons trouvé la liste suivante d'entreprises liées à votre domaine d'adresse e-mail: {emailAddress}",
    errorCompanyAlreadyRegistered:
      "Cette société a un compte existant avec cette adresse e-mail. Veuillez cliquer sur 'Retour' et sélectionnez-le."
  },
  companyBio: {
    companyLegalName: "Nom légal de l'entreprise",
    companyDoingBusinessAs: 'Faire des affaires comme',
    companyParentCompany: 'Société mère (le cas échéant)',
    yearCompanyWasFounded: 'Année de fondation',
    numberOfPermanentEmployees: 'Employés permanents',
    supplierCompanyOwnership: "Propriété de l'entreprise*",
    supplierCompanyOwnershipOptions: [
      { label: 'Propriété privée', value: 'Privately Owned' },
      { label: 'Propriété publique', value: 'Publicly Owned' },
      { label: 'Propriété du gouvernement', value: 'Government Owned' }
    ],
    unionizedCompany: "L'entreprise est syndiquée",
    companyPhoneNumber: "Téléphone de l'entreprise",
    companyWebsite: "Site Web d'entreprise",
    errorCompanyWebsite: 'Veuillez insérer une URL valide',
    companyEmailAddress: "E-mail de l'entreprise",
    errorEmailAddress: 'Veuillez insérer un e-mail valide',
    companyTaxIdNumber: "Num. d'identification fiscale de l'entreprise (EIN)",
    errorTaxIdNumber: "Le numéro d'identification fiscale doit comporter 9 chiffres",
    dunsNumber: "Numéro DUNS de l'entreprise",
    errorDunsNumber: 'Le numéro DUNS doit être composé de 9 chiffres',
    primaryNAICSCode: "Code SCIAN principal de l'entreprise",
    secondaryNAICSCode: "Code SCIAN secondaire de l'entreprise",
    errorNAICSCode: 'Le code SCIAN doit comprendre entre 2 et 6 chiffres',
    annualRevenueLabel: 'Revenu annuel {newAnnualRevenue} (USD)'
  },
  diversity: {
    radioGroupLabel: 'Avez-vous une classification de diversité?',
    errorDiversityList: 'Il y a eu une erreur, réessayez plus tard',
    errorUploadingFile: 'Erreur lors du téléchargement du fichier, réessayez plus tard',
    errorRequiredField: '*Champs requis',
    errorForbiddenCharacters: `Le nom de fichier ne doit pas inclure de caractères interdits : < > + & # ' / \\ * ? | "`,
    errorPermitedTypeFile: 'Types de fichiers autorisés: jpg, jpeg, gif, png, bmp, pdf, doc, docx',
    errorDates: "La date de début ne peut pas être postérieure à la date d'expiration.",
    permitedTypeFileTooltip:
      'Télécharger le certificat - Types de fichiers autorisés : jpg, jpeg, gif, png, bmp, pdf, doc, docx',
    tableColumns: [
      { id: 'classification', label: 'Classification de la diversité' },
      { id: 'document', label: 'Certificat Diversité', align: 'center' },
      { id: 'certificate', label: 'ID du certificat', align: 'center' },
      { id: 'startDate', label: 'Date de début', align: 'center' },
      { id: 'expDate', label: "Date d'expiration", align: 'center' }
    ],
    note:
      "REMARQUE: Ces informations peuvent être mises à jour une fois l'inscription terminée en vous connectant à la plateforme et en cliquant sur le lien Diversité.",
    modalText: 'Veuillez confirmer que vous souhaitez supprimer: {fileName}',
    modalCancelButton: 'Annulez',
    modalDeleteButton: 'Effacez'
  },
  productsServices: {
    searchPlaceholder: 'Rechercher...',
    cancelIconTooltip: 'Annulez',
    selectedProductsListTitle: 'Produits et services sélectionnés',
    addProductTooltip: 'Ajoutez un produit',
    removeProduct: 'Enlevez la sélection'
  },
  confirmation: {
    helperText: "Entrez un nom d'utilisateur et un mot de passe pour votre connexion",
    submitButtonText: 'Soumettre et se connecter',
    userNameError: "Le nom d'utilisateur doit comporter au moins 8 caractères",
    passwordError:
      'Le mot de passe doit avoir au moins 8 caractères avec 1 majuscule, 1 minuscule, 1 caractère spécial et 1 chiffre',
    passwordConfirmationError: 'Les mots de passe doivent correspondre',
    usernameLabel: "Nom d'utilisateur",
    passwordnameLabel: 'Mot de passe',
    confirmationPassLabel: 'Confirmez le mot de passe',
    usernameTaken: "Nom d'utilisateur déjà pris",
    successResponse: 'Fournisseur enregistré avec succès',
    errorResponse:
      'Nous ne pouvons pas enregistrer votre inscription. Veuillez réessayer. Si le problème persiste, veuillez contacter support@poweradvocate.com.'
  },
  common: {
    tagInstructionPrimary:
      "Ces données ont été générées à partir d'une soumission préalable par votre entreprise le {taggedDate}",
    tagInstructionSecondary: 'Veuillez vérifier tous les champs avant de sélectionner'
  },
  footer: {
    poweredBy: 'Alimenté par',
    rightsReserved: 'Tous les Droits sont Réservés',
    termsOfUse: "Conditions d'utilisation",
    privacyStatement: 'Déclaration de confidentialité',
    contactSupport: 'Contactez le support'
  },
  registrationLinkExpired: {
    headerText: 'Inscription expirée',
    title: 'Cet enregistrement a expiré.',
    description: 'Pour vous inscrire quand même et créer un compte pour de futures opportunités, veuillez cliquer sur ',
    here: 'ici'
  }
};

export default french;
